import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { ForgotserviceService } from './forgotservice.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
 
  forgotForm: any;
  constructor(private spinner: NgxSpinnerService, private http: Http, private formBuilder: FormBuilder, private routes: Router, private alertService: AlertService, private forgotserviceService: ForgotserviceService) {
      this.forgotForm = this.formBuilder.group({
      'email': ['', Validators.compose([
        Validators.required,
        Validators.email
      ])]
    });
  }
   

  ngOnInit() {
  }

  submit() {
    if(!this.forgotForm.valid){
      Object.keys(this.forgotForm.controls).forEach(field => { 
        const control = this.forgotForm.get(field);           
        control.markAsDirty({ onlySelf: true }); 
      });
      return;
    }
    this.spinner.show();
      this.forgotserviceService.check(this.forgotForm.value.email).then((res: any) => {
        this.spinner.hide();
        if(res.status){
          this.alertService.success(res.message);
          this.routes.navigate(['/login']);
        }else{
          this.spinner.hide();
          this.alertService.danger('Unautherized User');
        }
      }).catch((err: any) => {this.alertService.danger(err.message)
        this.spinner.hide();
      });
  }
}
